import { DatabaseWrapper } from '../../../shared/databases/database.wrapper';
import { Database } from '../../../shared/databases/database';
import { DatabaseEnum } from 'src/app/shared/databases/databases.enum';
import { RepConnWrapper } from '../../repconn/repconn.wrapper';
import { ObjectWrapper } from 'src/app/shared/wrappers/object.wrapper';
import { CommonEnums } from 'src/app/shared/common.enums';
import { Attribute } from 'src/app/shared/models/domain/attribute';

export class SpliceMachineWrapper extends DatabaseWrapper {

	constructor(database: Database) {
		super(database);

		this.dbTyp_Id = DatabaseEnum.splicemachine.ID;
		this.name = DatabaseEnum.splicemachine.NAME;
		this.code = DatabaseEnum.splicemachine.CODE;
		this.equivalentTag = DatabaseEnum.splicemachine.EQUIVALENT_TAG;
		this.conn_DbsTabName = 'Schemas';
		this.showSettingsTab = true;
		this.showHdfsSettingsTab = true;
		this.showAdvancePropertiesTab = false;
		this.showRepConnServiceNm = true;
		this.hideSchemaNmColumn = false;
		//data object tabs
        this.showDataObjectPropertiesTab=true;
        this.showDDLOption=true;
		this.showViewDataTabOption=true;
		this.isShowObjProperties=true;
		this.dataObjectConnDatabaseNm = 'Schema';
		this.hideDatabaseNmDbColumn = true;
		this.havingOnlySchemalColumn = true;
    this.showDataDescription = false;
	}

	validateRepConn(repConnWrapper: RepConnWrapper): void {
		if (repConnWrapper.repConn.conn.host == "") {
			repConnWrapper.inValid_Cds.push('NO_HOST');
		}

		if (repConnWrapper.repConn.conn.port == "") {
			repConnWrapper.inValid_Cds.push('NO_PORT');
		}

		if (repConnWrapper.repConn.conn_Usr.conn_Usr == "") {
			repConnWrapper.inValid_Cds.push('NO_CONN_APPUSR');
		}

		if (repConnWrapper.repConn.conn_Usr.usrPasswd == "") {
			repConnWrapper.inValid_Cds.push('NO_PASSWORD');
		}

		if (repConnWrapper.repConn.conn_Dbs.length != 0) {
			if (repConnWrapper.repConn.conn_Dbs[0].databaseNm == "") {
				repConnWrapper.inValid_Cds.push('NO_DATABASE_NM');
			}
		}

		if (repConnWrapper.repConn.conn.flagent_Id == -1) {
			repConnWrapper.inValid_Cds.push('ESM00202');
		}

		if (repConnWrapper.repConn.conn_Dbs.length < 1) {
			repConnWrapper.inValid_Cds.push('NO_DATABASE');
		}

		/*if(!repConnWrapper.repConn.conn.host.length)
		{
			return DIInValid_Cd.NATIVE_REP_CONNECTION_INVALID_HOST;
		}
		if(!repConnWrapper.repConn.conn.port.length)
		{
			return DIInValid_Cd.NATIVE_REP_CONNECTION_INVALID_PORT;
		}
		if(!repConnWrapper.repConn.conn_Usr.conn_Usr.length)
		{
			return DIInValid_Cd.NATIVE_REP_CONNECTION_INVALID_APPUSER;
		}
		if(!repConnWrapper.repConn.conn_Usr.usrPasswd.length)
		{
			return DIInValid_Cd.NATIVE_REP_CONNECTION_INVALID_APPUSER_PWD;
		}
		if( repConnWrapper.repConn.conn.flagent_Id == -1 )
		{
			return DIInValid_Cd.NATIVE_REP_CONNECTION_INVALID_AGENT;
		}
		if( repConnWrapper.repConn.conn_Dbs.length < 1 )
		{
			return DIInValid_Cd.NATIVE_REP_CONNECTION_INVALID;
		}
		return DICodes.SUCCESS_CODE;*/
	}
	getDerivedAttributeColumns(objectWrapper: ObjectWrapper, component: any, isMax: boolean = false, attributes: Array<Attribute> = new Array<Attribute>(),isHiveNative: boolean = false,hideOrderBy:boolean=true): Array<any> {
		return [
			this.attributeTabulator.getCheckBoxColumn(objectWrapper),
			this.attributeTabulator.getSrt_Order(),
			this.attributeTabulator.getAttr_Id(),
			this.attributeTabulator.getAttrNm(objectWrapper,component),
			this.attributeTabulator.getAttrDTyp_Id(objectWrapper),
			this.attributeTabulator.getAttrPrec(objectWrapper),
			this.attributeTabulator.getAttrScale(objectWrapper),
			this.attributeTabulator.getMaxFlag(objectWrapper, isMax),
			this.attributeTabulator.getOrderBy(objectWrapper, component,hideOrderBy),
			this.attributeTabulator.getPartitionflag(objectWrapper, isHiveNative),
			this.attributeTabulator.getAttrExprVal(objectWrapper, component),
			this.attributeTabulator.getValid_Cd(objectWrapper,component),
		]
	}

	getAttributeColumns(objectWrapper: ObjectWrapper,
        attributes: Array<Attribute> = new Array<Attribute>(), component: any = null,hideRowSelection:boolean=true): Array<any> {
        return [
	        	this.attributeTabulator.getCheckBoxColumn(objectWrapper,hideRowSelection),
				this.attributeTabulator.getSrt_Order(),
				this.attributeTabulator.getAttr_Id(),
				this.attributeTabulator.getAttrNm(objectWrapper,component),
				this.attributeTabulator.getAttrDTyp_Id(objectWrapper, attributes, component),
				this.attributeTabulator.getAttrPrec(objectWrapper),
				this.attributeTabulator.getAttrScale(objectWrapper),
				this.attributeTabulator.getNotNullFlag(objectWrapper),
				this.attributeTabulator.getAttrKeyTyp_Id(objectWrapper),
				this.attributeTabulator.getDescription(objectWrapper),
			]
	}

	// getRollupSelectAttributeColumns(objectWrapper: ObjectWrapper): Array<any> {
    //     return [
    //         this.attributeTabulator.getCheckBoxColumn(objectWrapper),
    //         this.lAttributeTabulator.getSrt_Order(),
    //         this.lAttributeTabulator.getLAttr_Id(),
    //         this.lAttributeTabulator.getLAttrNm(objectWrapper),
    //         this.lAttributeTabulator.getSelectColumn(objectWrapper),
    //         this.lAttributeTabulator.getAttrDTypNm(objectWrapper),
    //         this.lAttributeTabulator.getLAttrPrec(objectWrapper),
    //         this.lAttributeTabulator.getLAttrScale(objectWrapper),
    //         this.lAttributeTabulator.getLAttrType( objectWrapper ),
    //         this.lAttributeTabulator.getLAttrFunction( objectWrapper),
    //         this.lAttributeTabulator.getDistKeyFlag(objectWrapper),
    //         this.lAttributeTabulator.getOrgKeyFlag(objectWrapper),
    //         this.lAttributeTabulator.getPartFlag(objectWrapper),
    //         this.lAttributeTabulator.getOrderBy(objectWrapper)
    //     ]
    // }

	getLAttributeColumns(objectWrapper: ObjectWrapper): Array<any> {
        return [
	 		this.attributeTabulator.getCheckBoxColumn(objectWrapper),
            this.lAttributeTabulator.getSrt_Order(),
            this.lAttributeTabulator.getLAttr_Id(),
            this.lAttributeTabulator.getLAttrNm(objectWrapper),
            this.lAttributeTabulator.getSelectColumn(objectWrapper),
            this.lAttributeTabulator.getLAttrPrec(objectWrapper),
			this.lAttributeTabulator.getLAttrScale(objectWrapper),
			this.lAttributeTabulator.getLAttrType(objectWrapper),
			this.lAttributeTabulator.getLAttrFunction(objectWrapper),

        ]
    }

	getSourceAttributeColumns(objectWrapper: ObjectWrapper = null, isComplex: boolean = false, isShowPIIColumn: boolean = false, isGoogleAnalytics: boolean = false, isEncryptedFlag: boolean = false,isMax: boolean = false,component:any): Array<any> {
		return [
			this.attributeTabulator.getCheckBoxColumn(objectWrapper),
			this.attributeTabulator.getSrt_Order(),
			this.attributeTabulator.getAttr_Id(),
			this.attributeTabulator.getClevel(objectWrapper, isComplex),
			this.attributeTabulator.getAttrNm(objectWrapper,component),
			this.attributeTabulator.getAttrDTyp_Id(objectWrapper, objectWrapper.object.attributes, component),
			this.attributeTabulator.getAttrPrec(objectWrapper),
			this.attributeTabulator.getAttrScale(objectWrapper),
			this.attributeTabulator.getAttrPiiIdentifierFlag(objectWrapper, isShowPIIColumn),
			this.attributeTabulator.getEncryptedFlag(objectWrapper, isEncryptedFlag),
			this.attributeTabulator.getLnk_Attr_Id(objectWrapper),
			this.attributeTabulator.getLnk_Attr_Datatype(objectWrapper),
			this.attributeTabulator.getValid_Cd(objectWrapper,component),
		]
	}

	getConn_DbColumns(repConnWrapper: RepConnWrapper, component): Array<any> {
		return [
			this.conn_DbsTabultor.getCheckBoxColumn(repConnWrapper),
			this.conn_DbsTabultor.getSrt_Order(),
			this.conn_DbsTabultor.getName(repConnWrapper),
			this.conn_DbsTabultor.getSchemaNm(repConnWrapper, component),
			this.conn_DbsTabultor.getStgDb_Flag(repConnWrapper)
		]
	}
}
